import React from 'react';
import RegularButton from "../../components/contorols/RegularButton/RegularButton";
import {useNavigate} from "react-router-dom";

const PageNotFound = () => {
  const navigate = useNavigate();

  return (
    <div>
      <h1>404 - Page Not Found</h1>
      <p>Sorry, the page you are looking for does not exist.</p>
      <RegularButton buttonText="Proceed To Sign In" onClickHandler={() => navigate("/signin")}/>
    </div>
  );
};

export default PageNotFound;
